import { render, staticRenderFns } from "./bargainPage.vue?vue&type=template&id=30981953&scoped=true&lang=pug"
import script from "./bargainPage.vue?vue&type=script&lang=js"
export * from "./bargainPage.vue?vue&type=script&lang=js"
import style0 from "./bargainPage.vue?vue&type=style&index=0&id=30981953&prod&lang=scss&scoped=true"
import style1 from "./bargainPage.vue?vue&type=style&index=1&id=30981953&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30981953",
  null
  
)

export default component.exports